import PolicyEditor from './PolicyEditor'

const Privacy = () => (
  <PolicyEditor
    pageName='privacy-policy'
    label='Privacy Policy'
    defaults={{
      title: 'Privacy Policy',
      subtitle: 'Legal',
    }}
  />
)

export default Privacy
